import { render, staticRenderFns } from "./VwRow.vue?vue&type=template&id=12208df4&scoped=true&lang=pug&"
import script from "./VwRow.vue?vue&type=script&lang=ts&"
export * from "./VwRow.vue?vue&type=script&lang=ts&"
import style0 from "./VwRow.vue?vue&type=style&index=0&id=12208df4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12208df4",
  null
  
)

component.options.__file = "VwRow.vue"
export default component.exports